/**
 * Query parameter used by Adobe Sign when redirecting back to the application
 */
export const DIGITAL_SIGNATURE_STATUS_QUERY_PARAM = 'agreementStatus';

/**
 * Status value indicating that the digital signature has been completed
 */
export const DIGITAL_SIGNATURE_STATUS_COMPLETED = 'completed';
